/**
 * Whether the viewport can capture a PNG now, as the shell reports it to its host. A host
 * holds a capture request while the state is `pending` and answers `unavailable` with its
 * reason, so it never polls the canvas or guesses how long the canvas takes to mount.
 */
export const PENDING_CAPTURE = { status: 'pending' };
/**
 * The state the shell reports. A registered handler wins, since it exists only once the active view's renderer does,
 * but it waits until the scene is complete.
 */
export function previewCaptureStateOf({ capture, isSceneComplete, viewportError, }) {
    if (capture)
        return isSceneComplete ? { status: 'ready', capture } : PENDING_CAPTURE;
    if (viewportError)
        return { status: 'unavailable', reason: `The viewport crashed: ${viewportError.message}` };
    return PENDING_CAPTURE;
}
//# sourceMappingURL=previewCaptureState.js.map